// extracted by css-extract-rspack-plugin
export default {"fab":"fab-T75Vt7"};